import React, { useRef, useEffect } from "react";

export default function HpiForm({ hpi, meds, pmh, onChangeHpi, onChangeMeds, onChangePmh, isEditing=true }) {
  const generalRef = useRef(null);
  const transitionalRef = useRef(null);
  const currentMedsRef = useRef(null);
  const pastHistoryRef = useRef(null);

  const adjustTextareaHeight = (textarea) => {
    if (textarea) {
      textarea.style.height = "auto";
      textarea.style.height = `${textarea.scrollHeight}px`;
    }
  };

  const handleGeneralChange = (event) => {
    onChangeHpi({ ...hpi, HistoryofPresentIllness: event.target.value });
    adjustTextareaHeight(event.target);
  };

  const handleTransitionalChange = (event) => {
    onChangeHpi({ ...hpi, HistoryofPresentIllness1: event.target.value });
    adjustTextareaHeight(event.target);
  };

  const handleCurrentMedsChange = (event) => {
    onChangeMeds({ ...meds, CurrentMedications: event.target.value });
    adjustTextareaHeight(event.target);
  };

  const handlePastHistoryChange = (event) => {
    onChangePmh({ ...pmh, PMH2: event.target.value });
    adjustTextareaHeight(event.target);
  };

  useEffect(() => {
    adjustTextareaHeight(generalRef.current);
    adjustTextareaHeight(transitionalRef.current);
    adjustTextareaHeight(currentMedsRef.current);
    adjustTextareaHeight(pastHistoryRef.current);
  }, [hpi.HistoryofPresentIllness, hpi.HistoryofPresentIllness1, meds.CurrentMedications, pmh.PMH2]);

  return (
    <div className="cn-card">
      <h3>🧾 History of Present Illness (HPI)</h3>
      
      <label>
        <span style={{ marginRight: 8 }}>🗒️</span>
        General
      </label>
      <textarea 
        ref={generalRef}
        rows={1} 
        value={hpi.HistoryofPresentIllness || ""} 
        onChange={handleGeneralChange} 
        disabled={!isEditing}
        style={{
          width: "100%",
          minHeight: "40px",
          overflow: "hidden",
          resize: "none",
          boxSizing: "border-box"
        }}
      />
      
      <label>
        <span style={{ marginRight: 8 }}>🔁</span>
        Transitional Care Management (summary)
      </label>
      <textarea 
        ref={transitionalRef}
        rows={1} 
        value={hpi.HistoryofPresentIllness1 || ""} 
        onChange={handleTransitionalChange} 
        disabled={!isEditing}
        style={{
          width: "100%",
          minHeight: "40px",
          overflow: "hidden",
          resize: "none",
          boxSizing: "border-box"
        }}
      />

      <div className="row" style={{ marginTop: 8 }}>
        <div>
          <label>
            <span style={{ marginRight: 8 }}>✅</span>
            <input 
              type="checkbox" 
              checked={meds.Allmedicationsreviewedandreconciled || false}
              onChange={(e) => onChangeMeds({ ...meds, Allmedicationsreviewedandreconciled: e.target.checked })}
              disabled={!isEditing}
            />
            All medications reviewed and reconciled
          </label>
        </div>
      </div>
      
      <label>
        <span style={{ marginRight: 8 }}>💊</span>
        Current Medications
      </label>
      <textarea 
        ref={currentMedsRef}
        rows={1} 
        value={meds.CurrentMedications || ""} 
        onChange={handleCurrentMedsChange} 
        disabled={!isEditing}
        style={{
          width: "100%",
          minHeight: "40px",
          overflow: "hidden",
          resize: "none",
          boxSizing: "border-box"
        }}
      />

      <div className="row" style={{ marginTop: 8 }}>
        <div>
          <label>
            <span style={{ marginRight: 8 }}>✅</span>
            <input 
              type="checkbox" 
              checked={pmh.PMH || false}
              onChange={(e) => onChangePmh({ ...pmh, PMH: e.target.checked })}
              disabled={!isEditing}
            />
            No change in Past Medical History, reviewed
          </label>
        </div>
      </div>
      
      <label>
        <span style={{ marginRight: 8 }}>📚</span>
        Past Medical History
      </label>
      <textarea 
        ref={pastHistoryRef}
        rows={1} 
        value={pmh.PMH2 || ""} 
        onChange={handlePastHistoryChange} 
        disabled={!isEditing}
        style={{
          width: "100%",
          minHeight: "40px",
          overflow: "hidden",
          resize: "none",
          boxSizing: "border-box"
        }}
      />
    </div>
  );
}